<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <span>
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </span>
      </div>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="form"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <template v-for="brand in form.brands">
        <fieldset :key="brand.id">
          <legend>Brand</legend>
          <div class="form-group">
            <el-form-item label="Brand Slug">
              <el-input
                v-model="brand.brand_slug"
                clearable
              />
            </el-form-item>
          </div>
        </fieldset>
      </template>
    </el-form>
  </sticky-header-layout>
</template>

<script>
import { getTrendingBrandDetail, updateTrendingBrand } from '../../api/trendings'

export default {
  name: 'TrendingBrandDetail',
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        brands: [
          { title: '' },
          { image: '' },
          { link: '' },
        ],
      },
      isEdited: false,
      isLoading: false,
      isSaving: false,
    }
  },
  watch: {
    form: {
      handler() {
        this.isEdited = true
      },
      deep: true,
    },
  },
  mounted() {
    this.getTrendingBrand(this.slug)
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      return next(false)
    }

    if (!this.isEdited) {
      return next()
    }

    try {
      await this.$confirm(this.$t('message.leaveWithUnsavedChanges'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.leave'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      })
      return next()
    } catch (error) {
      return next(false)
    }
  },
  methods: {
    async editTrendingBrand(form) {
      this.isSaving = true
      try {
        await updateTrendingBrand(form.brands, this.slug)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async getTrendingBrand(slug) {
      this.isLoading = true
      try {
        const response = await getTrendingBrandDetail(slug)
        if (Array.isArray(response.data)) {
          this.form.brands = response.data
        }

        this.$nextTick(() => {
          this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        this.isLoading = false
      }
    },
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      this.goToTrendingBrandList()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    handleValidate() {
      return this.form.brands.every(brand => !!brand.brand_slug)
    },
    goToTrendingBrandList() {
      this.$router.push({ path: '/trending/brand-list' })
    },
    handleCancel() {
      this.goToTrendingBrandList()
    },
    handleSave() {
      if (this.handleValidate()) {
        this.editTrendingBrand(this.form, this.slug)
      } else {
        this.$alert(this.$t('error.pleaseFillInAndCheckErrors'), 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss">
.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
